import "@mdi/font/css/materialdesignicons.css";
import "@/assets/styles/font-display-fix.css"; // Override font-display: swap
import "vuetify/styles";

import { createVuetify } from "vuetify";
import { es, en } from "vuetify/locale";

// Solo importar componentes de labs que necesites
import { VDateInput } from "vuetify/labs/VDateInput";

export default createVuetify({
  // Solo registrar componentes de labs (el resto se auto-importa)
  components: {
    VDateInput,
  },

  locale: {
    locale: "es",
    fallback: "es",
    messages: { es, en },
  },

  date: {
    locale: {
      es: "es-ES",
      en: "en-GB",
    },
  },

  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#2f4858",
          secondary: "#c83d2d",
          tercero: "rgb(236,222,198)",
          background: "#FFFFFF",
          background2: "#ede7f6",
          info: "#2196F3",
          error: "#dc3545", // Vuetify usa "error" no "danger"
          warning: "#ffc107",
          success: "#28a745",
        },
      },
    },
  },

  defaults: {
    // Defaults globales para consistencia
    VBtn: {
      rounded: "lg",
    },
    VCard: {
      rounded: "xl",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
    },
    VSelect: {
      variant: "outlined",
      density: "comfortable",
    },
  },
});
